import type { RouteLocationNormalizedLoaded } from 'vue-router'

export const getProduct = ({
  params,
  query,
}: RouteLocationNormalizedLoaded) => {
  const lotteryId = getLotteryIdInCorrectCase(
    String(params.lotteryId || query.p),
  )
  if (lotteryId) return lotteryId.toLowerCase()

  let fallbackId = params.slug || query.p
  if (Array.isArray(fallbackId)) fallbackId = fallbackId[0]

  return fallbackId ? String(fallbackId).toLowerCase() : null
}
